import axios from "axios";
import React, { useContext, useLayoutEffect, useState, useRef} from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthHandleProps } from ".";
import { UserContext, UserPermission } from "../Provider";
import { InboxMessageContext } from "../Provider/InboxMessageContext";
import Header from "../components/Header";
import { httpGET } from "../utils/ajaxHelper";
import { PageContainerContext } from "../Provider";

const AuthLayout: React.FC<AuthHandleProps> = (props) => {
	const [user, setUser] = useState<UserPermission | undefined>();
	const inboxMessageContext = useContext(InboxMessageContext);

	const [renderUI, setRenderUI] = useState(false);

	const pageContainerDivRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		if (props.token) {
			httpGET({
				url: "/auth/me",
				config: {
					headers: { Authorization: "bearer " + props.token },
				},
			})
				.then((e) => {
					setUser(e);
					axios.interceptors.request.use(function (config) {
						config.headers.Authorization = "bearer " + props.token;
						return config;
					});
					setRenderUI(true);
				})
				.catch(() => {
					setUser(undefined);
					setRenderUI(true);
				});

			httpGET({
				url: `/InboxMessage/count-unread`,
				config: {
					headers: { Authorization: "bearer " + props.token },
				},
			})
				.then((e) => {
					inboxMessageContext?.setUnreadInboxMessage(e ?? 0);
				})
				.catch(() => {
					inboxMessageContext?.setUnreadInboxMessage(0);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!renderUI) {
		return null;
	}
	if (!user) {
		return <Navigate to="/404" />;
	}

	return (
		<UserContext.Provider value={user}>
			<PageContainerContext.Provider value={pageContainerDivRef}>
				<div ref={pageContainerDivRef} id="scrollableDiv" className="sizeFixedMobile:no-scrollbar-disable  mobile:h-[100dvh] mobile:overflow-y-auto tablet:h-[100dvh] tablet:overflow-y-auto">
					<Header />
					<Outlet />
				</div>
			</PageContainerContext.Provider>
		</UserContext.Provider>
	);
};

export default AuthLayout;
